// @flow
export { default } from './SettingsEtc';



// WEBPACK FOOTER //
// ./src/components/settings/SettingsEtc/index.js